import { QueryClient, QueryKey } from '@tanstack/react-query';

/**
 * Refreshes every cached query under `queryKey` after a mutation.
 *
 * Queries on screen are refetched straight away. Cached queries nobody is
 * watching (other pages, filters, a list the user navigates back to) are
 * dropped, so they load fresh on mount instead of showing stale rows first.
 */
export const refreshQueries = (
  queryClient: QueryClient,
  queryKey: QueryKey
) => {
  queryClient.removeQueries({ queryKey, type: 'inactive' });
  return queryClient.invalidateQueries({ queryKey });
};
